module.exports = __webpack_public_path__ + "img/logo.80cf483c.png";